import PropTypes from 'prop-types';
import React from 'react';
import SurveyIcon from '../SurveyIcon';
import classnames from 'classnames';
import styled from 'styled-components';

const PureRatingIcon = ({
  curVal,
  disabled,
  isHovered,
  hoverVal,
  value,
  onClick,
  onHoverOrFocus,
  onBlurOrMouseLeave,
  ...rest
}) => {
  const isEqualToHover = value === hoverVal;
  const isLessThanHover = value < hoverVal;
  const isOutsideHover = value > hoverVal;
  const isWithinSelection = value <= curVal;

  return (
    <li className="d-in">
      <Btn
        className={classnames('srv-q-rtg-btn trans-bounce input-reset p1', {
          selected: !isHovered && isWithinSelection,
          hover: isHovered && isLessThanHover,
          'selected-lt-hover':
            isHovered &&
            isWithinSelection &&
            (isLessThanHover || isEqualToHover),
          'selected-gt-hover': isHovered && isWithinSelection && isOutsideHover,
        })}
        disabled={disabled}
        onClick={onClick}
        onFocus={() => onHoverOrFocus(value)}
        onMouseEnter={() => onHoverOrFocus(value)}
        onBlur={() => onBlurOrMouseLeave()}
        onMouseLeave={() => onBlurOrMouseLeave()}
        type="button"
      >
        <SurveyIcon
          className="srv-q-rtg-s fs-32"
          width="32"
          height="32"
          {...rest}
        />{' '}
        <span className="visuallyhidden">{value}</span>
      </Btn>
    </li>
  );
};

PureRatingIcon.displayName = 'PureRatingIcon';

PureRatingIcon.propTypes = {
  active: PropTypes.bool,
  curVal: PropTypes.number,
  disabled: PropTypes.bool,
  hoverVal: PropTypes.number,
  isHovered: PropTypes.bool,
  onBlurOrMouseLeave: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  onHoverOrFocus: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PureRatingIcon;

const HUE = '200';

const gray = lightness => `hsl(${HUE}, 2%, ${lightness})`;
const color = (lightness, saturation = '100%') =>
  `hsl(${HUE}, ${saturation}, ${lightness})`;

const EMPTY = gray('80%');
const HOVER = color('65%');
const ACTIVE = color('22%');
const SELECTED = color('42%');
const SELECTED_GT_HOVER = gray('65%');
const SELECTED_LT_HOVER = color('42%');

const Btn = styled.button`
  color: ${EMPTY};
  &:disabled {
    cursor: not-allowed;
    &:hover,
    &.hover,
    &:focus {
      color: ${EMPTY};
    }
    &.selected {
      color: ${SELECTED_GT_HOVER};
    }
  }
  &:not(disabled) {
    &:hover,
    &.hover,
    &:focus {
      color: ${HOVER};
    }
    &:focus {
      transform: scale(1.2);
      transition-property: all;
      transition-duration: 0.2s;
    }
    &.selected {
      color: ${SELECTED};
    }
    &.selected-gt-hover {
      color: ${SELECTED_GT_HOVER};
    }
    &.selected-lt-hover {
      color: ${SELECTED_LT_HOVER};
    }
    &:active,
    &.active {
      color: ${ACTIVE};
    }
  }
`;
